<template>
    <!-- modal-xl -->
    <b-modal id="certificateAuthenticationModal" size="xl" title="Certificate Authentication" title-class="font-18" hide-footer>
        <div class="row row-container">
            <div class="left-pane">
                <h4 class="mb-3">{{ authenticationForm.company_name }}</h4>
                <b-form-group label="Vat no:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4" label-size="sm">
                    <b-form-input
                        v-model="$v.authenticationForm.vat_no.$model"
                        :state="validateState('vat_no')"
                        aria-describedby="input-1-live-feedback"
                        type="text"
                        class="b-form-input"
                        size="sm"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> {{ vatNoErrorMessage }} </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="Reg no:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4" label-size="sm">
                    <b-form-input
                        v-model="$v.authenticationForm.company_reg.$model"
                        :state="validateState('company_reg')"
                        aria-describedby="input-1-live-feedback"
                        type="text"
                        class="b-form-input"
                        size="sm"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> {{ regNoErrorMessage }} </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="Certificate No:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4" label-size="sm">
                    <b-form-input
                        v-model="$v.authenticationForm.certificate_no.$model"
                        :state="validateState('certificate_no')"
                        aria-describedby="input-1-live-feedback"
                        type="text"
                        class="b-form-input"
                        size="sm"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="Issue Date:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4" label-size="sm">
                    <b-form-input
                        v-model="$v.authenticationForm.issue_date.$model"
                        :state="validateState('issue_date')"
                        aria-describedby="input-1-live-feedback"
                        type="date"
                        class="b-form-input"
                        size="sm"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="Expiry Date:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4" label-size="sm">
                    <b-form-input
                        v-model="$v.authenticationForm.expiry_date.$model"
                        :state="validateState('expiry_date')"
                        aria-describedby="input-1-live-feedback"
                        type="date"
                        class="b-form-input"
                        size="sm"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label-size="sm" label="Authentication Result:" label-cols-sm="4" class="b-form-group align-text-setting">
                    <b-form-select
                        @change="onChangeVetting('authentication_result')"
                        v-model="$v.authenticationForm.authentication_status.$model"
                        :state="validateState('authentication_status')"
                        aria-describedby="input-1-live-feedback"
                        :options="vetting_status_options_authentication"
                        size="sm"
                    ></b-form-select>
                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="Authenticated By:" label-size="sm" label-cols-sm="4" class="b-form-group align-text-setting">
                    <b-form-select
                        @change="onChangeVetting('authentication_user_id')"
                        v-model="authenticationForm.authentication_user_id"
                        aria-describedby="input-1-live-feedback"
                        :options="team_member_options"
                        size="sm"
                    ></b-form-select>
                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="Authenticated Date:" label-size="sm" label-for="" class="b-form-group align-text-setting" label-cols-sm="4">
                    <b-form-input
                        disabled
                        v-model="authenticationForm.authentication_date"
                        aria-describedby="input-1-live-feedback"
                        size="sm"
                        type="text"
                        class="b-form-input not-allowed-pointer"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                        {{ vatNoErrorMessage }}
                    </b-form-invalid-feedback>
                </b-form-group>

                <div class="group-of-actions b-form-group">
                    <b-form-group label="Notes:" label-for="textarea-formatter" class="">
                        <b-form-textarea
                            v-model="authenticationForm.proof_notes"
                            id="textarea-formatter"
                            placeholder="Editable"
                            clas
                        ></b-form-textarea>
                    </b-form-group>
                </div>

                <b-alert class="b-form-group text-center" variant="danger" :show="proof_error" dismissible> You must upload Proof </b-alert>

                <div class="group-of-actions d-flex justify-content-center">
                    <!-- <b-button variant="primary" type="button" class="btn btn-primary m-1 mt-2">
                        Upload Proof
                    </b-button> -->
                    <div class="input-file m-1 mt-2">
                        <input @change="onFileSelected" class="btn btn-primary" ref="file" type="file" style="display: none;" />
                        <div class="btn btn-primary" @click="selectFile()">Upload Proof</div>
                    </div>

                    <!-- <div class="group-of-actions d-flex "> -->
                    <b-button @click="newWindow" variant="primary" type="button" class="btn btn-primary m-1 mt-2">
                        <i class="mdi mdi-dock-window mr-1"></i> View
                    </b-button>

                    <b-button @click="submit" variant="primary" type="button" class="btn btn-primary m-1 mt-2 float-right">
                        Submit
                    </b-button>
                </div>
            </div>

            <div class="right-pane" v-if="selectedFile">
                <embed :src="selectedFilePreview" class="w-100 h-100" />
            </div>
            <div v-else class="right-pane d-flex justify-content-center">
                <div class="text-center font-weight-bold ">Upload proof to preview it</div>
            </div>
        </div>

        <div class="modal-footer mt-3">
            <b-button variant="primary" type="button" class="btn btn-primary" @click="goBack">
                Back
            </b-button>
            <b-button variant="primary" type="button" class="btn btn-primary" @click="closeModal">
                Close
            </b-button>
        </div>
    </b-modal>
</template>

<script>
//eslint-disable-next-line
import { required, minLength, maxLength, numeric, date } from "vuelidate/lib/validators";
import {
    adminComputed,
    suppliersComputed,
    suppliersMethods,
    certificateValidationMethods,
    vettingComputed,
    vettingMethods,
} from "../../state/helpers";
import Swal from "sweetalert2";

export default {
    data: () => ({
        proof_error: false,
        selectedFile: "",
        selectedFilePreview: "",
        formSubmit: false,
        authenticationForm: {
            certificate_id: "",
            certificate_no: "",
            company_name: "",
            vat_no: "",
            company_reg: "",
            issue_date: "",
            expiry_date: "",
            authentication_status: null,
            // vetting_status: null,
            vetting_by: null,
            authentication_date: null,

            proof_notes: "",
            authentication_proof: "",
            authentication_user: "",
            authentication_user_id: "",
        },
        vetting_status_options: [
            { value: null, text: "-- Please Select --", disabled: true },
            { value: "Pending", text: "Pending" },
            { value: "Authentic", text: "Authentic" },
            { value: "Not Authentic", text: "Not Authentic" },
        ],
        vetting_status_options_authentication: [
            { value: null, text: "Please select an option", disabled: true },
            { value: "Not vetted", text: "Not vetted" },
            { value: "Authentic", text: "Authentic" },
            { value: "Altered", text: "Altered" },
            { value: "Not issued", text: "Not issued" },
            { value: "Withdrawn", text: "Withdrawn" },
            { value: "Pending Authentication", text: "Pending Authentication" },
        ],
    }),
    validations: {
        authenticationForm: {
            company_name: {
                required,
            },

            vat_no: {
                conditionalRequired(value) {
                    const isVatNoFilled = !!value;
                    const isCompanyRegFilled = !!this.authenticationForm.company_reg;
                    return isVatNoFilled || isCompanyRegFilled;
                },
                minLength: minLength(10),
                maxLength: maxLength(10),
                numeric,
            },
            company_reg: {
                conditionalRequired(value) {
                    const isVatNoFilled = !!this.authenticationForm.vat_no;
                    const isCompanyRegFilled = !!value;
                    return isVatNoFilled || isCompanyRegFilled;
                },
                minLength: minLength(3),
            },
            certificate_no: {
                required,
            },
            issue_date: {
                required,
            },
            expiry_date: {
                required,
            },
            authentication_status: {
                required,
            },
            authentication_user_id: {
                required,
            },
        },
    },
    computed: {
        ...adminComputed,
        ...suppliersComputed,
        ...vettingComputed,
        team_member_options() {
            let teamMemberOptions = [{ value: null, text: "Please select an option", disabled: true }];

            this.teamMembersForCertificates.map((teamMember) => {
                teamMemberOptions.push({ value: teamMember.id, text: `${teamMember.first_name} ${teamMember.last_name}` });
            });

            return teamMemberOptions;
        },
        vatNoErrorMessage() {
            if (!this.$v.authenticationForm.vat_no.$dirty) return "";
            if (!this.$v.authenticationForm.vat_no.conditionalRequired) {
                return "Either a VAT No or Reg No must be provided.";
            }
            if (this.$v.authenticationForm.vat_no.$error) {
                if (this.$v.authenticationForm.vat_no.maxLength) {
                    return "VAT No must be 10 digits long.";
                }
                if (this.$v.authenticationForm.vat_no.$params.numeric) {
                    return "Can only be numbers.";
                }
                return "A Vat No can only be 10 digits long.";
            }
            return "";
        },
        regNoErrorMessage() {
            if (!this.$v.authenticationForm.company_reg.$dirty) return "";
            if (!this.$v.authenticationForm.company_reg.conditionalRequired) {
                return "Either a Reg No or Vat no must be provided.";
            }
            if (this.$v.authenticationForm.company_reg.$error) {
                if (this.$v.authenticationForm.company_reg.$params.minLength) {
                    return "Reg No must be atleast 3 characters long";
                }
                return "Required";
            }
            return "";
        },
    },
    methods: {
        ...suppliersMethods,
        ...certificateValidationMethods,
        ...vettingMethods,
        onChangeVetting(input) {
            if (input == "authentication_result") {
                //eslint-disable-next-line
                console.log("in the vetting status");
                // this.authenticationForm.vetting_by = null;
                this.authenticationForm.authentication_user_id = null;
                this.authenticationForm.authentication_date = null;
            }

            if (input == "authentication_user_id") {
                //eslint-disable-next-line
                console.log("in the vetting status");
                // this.authenticationForm.vetting_by = null;
                this.authenticationForm.authentication_date = null;
            }
        },
        goBack() {
            //eslint-disable-next-line
            console.log("I was clicked");
            this.$emit("handleModal", "certificateEditModal");
            this.closeModal();
        },
        selectFile() {
            let fileInputElement = this.$refs.file;
            fileInputElement.click();

            //eslint-disable-next-line
            // console.log("target", e, fileInputElement);
            // ...
        },
        onFileSelected(event) {
            //eslint-disable-next-line

            // this.selectedFile = event.target.files[0];
            this.selectedFile = URL.createObjectURL(event.target.files[0]);
            this.selectedFilePreview = URL.createObjectURL(event.target.files[0]) + "#page=1&zoom=75&toolbar=0";
            //eslint-disable-next-line
            console.log(this.selectedFile, event.target.files[0]);

            // !
            // this.certificate_details.certificate = this.$refs.file.files[0];
            this.authenticationForm.authentication_proof = event.target.files[0];

            this.proof_error = false;
        },
        validateState(name) {
            if (this.formSubmit) {
                const { $dirty, $error } = this.$v.authenticationForm[name];
                return $dirty ? !$error : null;
            }
        },
        closeModal() {
            this.$bvModal.hide("certificateAuthenticationModal");
        },
        handleDates(date) {
            if (date == "issue_date") {
                return this.selected_supplier_certificate.issue_date.substring(0, 10);
            } else {
                return this.selected_supplier_certificate.expiry_date.substring(0, 10);
            }
        },
        localSetCertificateDetails() {
            this.authenticationForm.certificate_id = this.selected_supplier_certificate.id;
            this.authenticationForm.company_name = this.selected_supplier_certificate.company_name;
            this.authenticationForm.vat_no = this.selected_supplier_certificate.vat_no;
            this.authenticationForm.company_reg = this.selected_supplier_certificate.company_reg;
            this.authenticationForm.certificate_no = this.selected_supplier_certificate.certificate_no;
            this.authenticationForm.expiry_date = this.selected_supplier_certificate.expiry_date.substring(0, 10);
            this.authenticationForm.issue_date = this.selected_supplier_certificate.issue_date.substring(0, 10);
            this.authenticationForm.proof_notes = this.selected_supplier_certificate.authentication_notes;

            this.authenticationForm.authentication_user = this.username;
            this.authenticationForm.authentication_user_id = this.user_id;

            this.authenticationForm.authentication_status = this.selected_supplier_certificate.authentication_status;
            this.authenticationForm.authentication_user_id = this.selected_supplier_certificate.authentication_user_id;
            this.authenticationForm.authentication_date = this.selected_supplier_certificate.authentication_date;

            this.selectedFile = this.selected_supplier_certificate.authentication_src + "#page=1&zoom=75&toolbar=0";
            this.selectedFilePreview = this.selected_supplier_certificate.authentication_src + "#page=1&zoom=75&toolbar=0";
        },
        submit() {
            this.formSubmit = true;

            if (this.authenticationForm.authentication_proof.length < 2) {
                this.proof_error = true;
            }

            this.$v.authenticationForm.$touch();
            if (this.$v.authenticationForm.$anyError) {
                return;
            }

            if (this.proof_error == true) return;

            // this.shareCertificate
            Swal.fire({
                title: `Authenticate `,
                text: `Are you sure?`,
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes",
            }).then((result) => {
                if (result.value) {
                    this.saveAuthenticationProof(this.authenticationForm).then(() => {
                        // this.formSubmit = false;
                        // this.closeModal();
                        Swal.fire({ title: ``, text: "Certificate was Authenticated", icon: "success" });
                        this.closeModal();
                        this.$emit("handleModal", "certificateEditModal");
                        // this.setSearchForCertificatesDetails(null);
                        // this.localSetCertificateDetails(); // this will reset the local component state if called here like this
                    });
                }
            });
        },
        newWindow() {
            window.open(this.selectedFilePreview, "_blank");
        },
    },
    mounted() {
        // alert("ya");
        //eslint-disable-next-line
        console.log("the certificate details:", this.selected_supplier_certificate);
        this.localSetCertificateDetails(); // initial load of component
    },
};
</script>

<style lang="scss" scoped>
//   the default style attached to modal footer  border-top: 1px solid #eff2f7;
.align-text-setting {
    text-align: right;
}
.height {
    min-height: 500px;
}

// this makes the left and right pane in the flex
.row-container {
    display: flex;
    padding: 10px;
}

.left-pane {
    width: 40%;

    .b-form-group {
        margin-right: 50px;
    }
    .b-form-input {
        max-width: 100%;
    }
}
.group-of-actions {
    border-top: 1px solid #eff2f7 !important;
    margin-top: 25px;
    padding-top: 15px;
    margin-right: 25px;
}

.button-width {
    width: 200px;
}

.right-pane {
    // padding: 4px;
    width: 59%;
    display: flex;
    flex-direction: column;
    border: 1px solid black;
}

// the purpose of this media query is simply to make the contents of modal display flex-column
// and then for the panes to have a width off 100% instead of 50%
@media only screen and (max-width: 990px) {
    .align-text-setting {
        text-align: left;
    }
    .row-container {
        flex-direction: column;
    }

    .left-pane {
        width: 100%;
    }

    .right-pane {
        width: 100%;
        margin-top: 25px;
        height: 350px;
    }
}
.not-allowed-pointer {
    cursor: not-allowed;
}
</style>
